module.exports = __webpack_public_path__ + "static/media/furnizori-delete.cb303522.svg";